<template>
  <div class="h-[280px] flex flex-col items-center justify-center">
    <div class="flex flex-col items-center gap-4">
      <div class="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center" :class="{'animate-pulse': exporting}">
        <span class="material-symbols-outlined text-primary !text-5xl">description</span>
      </div>
      <div class="text-center">
        <p class="text-gray-800 text-center items-center flex justify-center font-medium mb-2">
          {{ t('assets.dashboard.export.title', 'Export Keywords') }} </p>
        <p class="text-gray-600 text-sm mb-4">
          {{ t('assets.dashboard.export.message', 'Export your keywords to Excel format') }} </p>
        
        <VTooltip :displayCondition="!canExport" :title="t('assets.dashboard.export.buttonMessage', 'Select at least one asset to export')">
          <template #content>
            <custom-button :isLoading="exporting" :isDisabled="!canExport" @click="openExportModal" color="primary" size="md" :button-text="t('assets.dashboard.export.exportButton', 'Export to Excel')"/>
          </template>
        </VTooltip>
      </div>
    </div>
    
    <!-- Export Modal -->
    <ExportModal v-model="showExportModal" :assetList="assetList" @update:exporting="updateExporting" />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useAssetStore } from '@/stores/asset'
import CustomButton from '@/components/base/buttons/VButton.vue'
import VTooltip from '@/components/common/VTooltip.vue'
import ExportModal from '@/components/exports/ExportModal.vue'

const { t } = useI18n()
const assetStore = useAssetStore()
const exporting = ref(false)
const showExportModal = ref(false)

const props = defineProps({
  assetList: {
    type: Array,
    default: () => [],
  },
})

const canExport = computed(() => {
  // Enable export if we have at least one asset ID
  return props.assetList.length > 0 || assetStore.assetId
})

const openExportModal = () => {
  showExportModal.value = true
}

const updateExporting = (value) => {
  exporting.value = value
}

defineEmits([])
</script>